import React from "react";
import "./ReportStyle.css";
import { COLORS } from "../../../Theme/variables";
const selectedStyle = {
  backgroundColor: COLORS.primary,
  color: "white",
};

const ReportPicker = ({ currentReport, setReport }) => {
  return (
    <div id="reportPickerRow">
      <div
        className="reportChoice"
        style={currentReport === "purchase" ? selectedStyle : {}}
        onClick={() => setReport("purchase")}
      >
        <p className="reportChoiceText">Purchase</p>
      </div>
      <div
        className="reportChoice"
        style={currentReport === "week" ? selectedStyle : {}}
        onClick={() => setReport("week")}
      >
        <p className="reportChoiceText">Weekly</p>
      </div>
      <div
        className="reportChoice"
        style={currentReport === "month" ? selectedStyle : {}}
        onClick={() => setReport("month")}
      >
        <p className="reportChoiceText">Monthly</p>
      </div>
      <div
        className="reportChoice"
        style={currentReport === "all" ? selectedStyle : {}}
        onClick={() => setReport("all")}
      >
        <p className="reportChoiceText">All</p>
      </div>
    </div>
  );
};

export default ReportPicker;
